import React, { useEffect, useState } from "react";
import { Accordion } from "discover.medical.react-component-library";
import { ListStyledContentBlock } from "./_.styled";

const ContentBlockAccordion = ({
  testId,
  subContentItem,
  childSelectedReferences,
  isAccordion,
  preProcessors,
  isPrintSelected,
}) => {
  const [isOpen, setIsOpen] = useState(
    (isAccordion && isAccordion.isOpen) || false
  );
  useEffect(() => {
    if (isPrintSelected || (isAccordion && isAccordion.isOpen)) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [isAccordion, isPrintSelected]);
  return (
    <>
      <Accordion
        data-testid={testId}
        toggleText={subContentItem.title}
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        animation={false}
        id={subContentItem.id}
      >
        <ListStyledContentBlock
          children={subContentItem.data}
          preProcessors={preProcessors}
          printHide={!childSelectedReferences.includes(subContentItem.id)}
        />
      </Accordion>
    </>
  );
};

ContentBlockAccordion.displayName = "ContentBlockAccordion";
export default ContentBlockAccordion;
